import { Alert, Stack, Text } from '@mantine/core';
import { StepExecution, getStepExecutionChildScopeState } from '@/types/stepExecutions.ts';
import { ExecutionStatus } from '@/types/statuses.ts';

type FailureHandlerOutcomeNarrativeProps = {
  stepExecution: StepExecution;
};

const FailureHandlerOutcomeNarrative = ({ stepExecution }: FailureHandlerOutcomeNarrativeProps) => {
  const childScopeState = getStepExecutionChildScopeState(stepExecution);
  const protectedScope = childScopeState?.find((scope) => scope.key === 'protected');
  const handlerScope = childScopeState?.find((scope) => scope.key === 'handler');

  if (!protectedScope || !isIssueStatus(protectedScope.status)) {
    return null;
  }

  const recoveryText = getRecoveryText(handlerScope?.status);

  return (
    <Alert color="yellow" variant="light" title="Protected work outcome">
      <Stack gap={4}>
        <Text size="sm">{protectedScope.terminal_message || 'Protected work completed with issues.'}</Text>
        <Text size="sm" c="dimmed">{recoveryText}</Text>
      </Stack>
    </Alert>
  );
};

const isIssueStatus = (status: ExecutionStatus) =>
  status === ExecutionStatus.Errors || status === ExecutionStatus.PartiallyCompleted;

const getRecoveryText = (status?: ExecutionStatus) => {
  if (status === ExecutionStatus.Completed) {
    return 'Error handling completed; the original issues still need review.';
  }
  if (
    status === ExecutionStatus.Active ||
    status === ExecutionStatus.ActiveWithErrors ||
    status === ExecutionStatus.Pending ||
    status === ExecutionStatus.Preprocessing ||
    status === ExecutionStatus.Rerunning ||
    status === ExecutionStatus.RerunPreparing
  ) {
    return 'Error handling is running for the original issues.';
  }
  return 'Error handling did not complete; the original issues still need review.';
};

export default FailureHandlerOutcomeNarrative;
